import React from 'react';
import _ from 'lodash';
import { Menu } from 'semantic-ui-react';
import history from '../../lib/history';
import * as logo from 'assets/logo.svg';
import './style.css'

const NavHeader = (props) => {
  const { activeItem, logoutUser, isAuthed } = props;

  return (
    <Menu className="nav" secondary>
      <Menu.Item className='logo' name='logo' onClick={() => { history.push('/') }}>
        <img src={logo} alt="logo"/>
      </Menu.Item>
      <Menu.Menu position='right'>
        { isAuthed ? (
          /* <Menu.Item as='a' name='home' active={activeItem === '/app'} onClick={this.handleItemClick} /> */
          <Menu.Item
            className="button"
            name='logout'
            onClick={logoutUser} />
        ) : (
          !_.includes(history.location.pathname, '/login') &&
            <Menu.Item
              className="button"
              name='login'
              onClick={() => history.push('/login')} />
        ) }
      </Menu.Menu>
    </Menu>
  )
}

export default NavHeader;



// WEBPACK FOOTER //
// ./src/components/NavHeader/index.js